import { render } from "./VerifySlide.vue?vue&type=template&id=521b189a&scoped=true"
import script from "./VerifySlide.vue?vue&type=script&lang=js"
export * from "./VerifySlide.vue?vue&type=script&lang=js"

import "./VerifySlide.vue?vue&type=style&index=0&id=521b189a&lang=scss&scoped=true"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521b189a"]])

export default __exports__